var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.1641 16.6807C14.3108 16.6807 17.6724 13.3191 17.6724 9.1724C17.6724 5.02566 14.3108 1.66406 10.1641 1.66406C6.01735 1.66406 2.65576 5.02566 2.65576 9.1724C2.65576 13.3191 6.01735 16.6807 10.1641 16.6807Z",
    fill: "#347D73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.314 15.7917C19.039 15.2833 18.4556 15 17.6723 15C17.0806 15 16.5723 15.2417 16.2723 15.6583C15.9723 16.075 15.9056 16.6333 16.089 17.1917C16.4473 18.275 17.0723 18.5167 17.414 18.5583C17.464 18.5667 17.514 18.5667 17.5723 18.5667C17.939 18.5667 18.5056 18.4083 19.0556 17.5833C19.4973 16.9417 19.5806 16.3 19.314 15.7917Z",
    fill: "#347D73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNormal);
export default __webpack_public_path__ + "static/media/search-normal.5f33f8e7cded9b9c4894cb761d2dc0c0.svg";
export { ForwardRef as ReactComponent };